// extracted by mini-css-extract-plugin
export default {"root":"text-block-module--root--01371","title":"text-block-module--title--c99ce","text":"text-block-module--text--d5993"};